import { render, staticRenderFns } from "./SubOshaYearList.vue?vue&type=template&id=0ee45b86"
import script from "./SubOshaYearList.vue?vue&type=script&lang=js"
export * from "./SubOshaYearList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports